export const CHANGE_TOKEN = "CHANGE_TOKEN"
export const CHANGE_LANGUAGUE = "CHANGE_LANGUAGUE"
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE"
export const CHANGE_USER_DATA = "CHANGE_USER_DATA"
export const CHANGE_NOTIFICATIONS = "CHANGE_NOTIFICATIONS"
export const CHANGE_RECEIVING_ORDER_STATUS = "CHANGE_RECEIVING_ORDER_STATUS"